import type { ConfigurationContextValue } from "../../root/ConfigurationContext";

/**
 * The branding (app name and logos) is global to the platform; every other
 * setting belongs to the team (see the team_configuration table).
 */
export const BRANDING_KEYS = [
  "title",
  "lightModeLogo",
  "darkModeLogo",
] as const;

type BrandingKey = (typeof BRANDING_KEYS)[number];
export type Branding = Partial<Pick<ConfigurationContextValue, BrandingKey>>;
export type TeamSettings = Partial<
  Omit<ConfigurationContextValue, BrandingKey>
>;

const isBrandingKey = (key: string): key is BrandingKey =>
  (BRANDING_KEYS as readonly string[]).includes(key);

export const pickBranding = (config: Record<string, unknown> = {}): Branding =>
  Object.fromEntries(
    Object.entries(config).filter(([key]) => isBrandingKey(key)),
  ) as Branding;

export const omitBranding = (
  config: Record<string, unknown> = {},
): TeamSettings =>
  Object.fromEntries(
    Object.entries(config).filter(([key]) => !isBrandingKey(key)),
  ) as TeamSettings;

export const isSameBranding = (a: Branding, b: Branding): boolean =>
  BRANDING_KEYS.every((key) => (a[key] ?? null) === (b[key] ?? null));
